export default __webpack_public_path__ + "assets/models/47d27f8807b67d06f9207b194d808246.glb";